module.exports = __webpack_public_path__ + "static/img/page1.6397e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgToys/page1.jpg
// module id = ZIog
// module chunks = 47